import client from 'providers/fetchClient'
import { formatCPFToNumber, formatName } from 'helpers'

export const createInvestor = data =>
  client.post('/v3/investors/signup', {
    ...data,
    document_number: formatCPFToNumber(data.document_number),
    first_name: formatName(data.first_name),
    last_name: formatName(data.last_name),
    investor_status_id: 1
  })
